@if (entityMap !== undefined) {
  <div class="grid-x">
    <div class="cell small-12">
      <h4 class="epsilon small">Entity Editor</h4>
    </div>
    <div class="cell small-12">
      Mappings for Entity {{entityMap.entity.entityName}}
    </div>
    <div class="cell small-6">
      <label for="txtbxEntityMapName">Map Name:</label>
    </div>
    <div class="cell small-6">
      <input type="text" id="txtbxEntityMapName" [(ngModel)]="entityMap.mapName" />
    </div>
    <div class="cell small-6">
      <label for="txtbxEntityMapName">ID Selector Rule:</label>
    </div>
    <div class="cell small-6">
      <input type="text" id="txtbxIdSelectorRule" [(ngModel)]="entityMap.idSelectorRule" />
    </div>
  </div>
  @if (mapIsSubordinate(entityMap)) {
    <div class="grid-x">
      <div class="cell small-6">
        <label for="selProperties">
          Relates to Parent via:
        </label>
      </div>
      <div class="cell small-6">
        <select class="no-margin" id="selProperties" [(ngModel)]="entityMap.relationalProperty">
          @for (property of entityMap.propertyMaps; track property) {
            <option [value]="property.propertyName">{{property.propertyName}}</option>
          }
        </select>
      </div>
    </div>
  }
  <div class="grid-x minor-margin-top">
    <div class="cell small-6">
      <label for="chkCasing">
        Relate casing plan?
      </label>
    </div>
    <div class=" cell small-6">
      <input type="checkbox" id="chkCasing" [(ngModel)]="entityMap.relateCasingPlan" (ngModelChange)="relateCasingPlanChanged()" />
    </div>
  </div>
  @if (entityMap.relateCasingPlan) {
    <div class="grid-x minor-margin-top">
      <div class="cell small-6">
        <label for="txtCasingContext">
          Casing plan will be stored in context at:
        </label>
      </div>
      <div class=" cell small-6">
        <input type="text" id="txtCasingContext" [(ngModel)]="entityMap.casingPlanContext" />
      </div>
    </div>
  }
  @if (entityHasChanged) {
    <div class="grid-x minor-margin-top">
      <div class="cell small-7 padding-right entity-changed-alert">
        Entity has been updated since maps were generated.
      </div>
      <div class="cell small-5">
        <button class="button button-hollow" attr.aria-label="Update Entity Maps" (click)="updateEntity()">Update Entity Maps</button>
      </div>
    </div>
  }
  <div class="form-button-group">
    <button class="button button-hollow" (click)="saveMap()" attr.aria-label="Save {{entityMap.mapName}}">Save Edits</button>
    <button class="button button-hollow" (click)="cancel()" attr.aria-label="Cancel Edits To {{entityMap.mapName}}">Cancel Edits</button>
  </div>
  <hr />
  <div class="grid-x">
    <div class="cell small-12 map-comment">
      Copy context values from the context tree on the left, and use the <span class="show-for-sr">Paste Value Into </span>
      <svg-icon icon="icon-reply" class="tiny medium-gray" aria-hidden="true"></svg-icon> button to paste them in to the appropriate fields OR
    </div>
    <div class="cell small-12 map-comment">
      enter a constant value into the textbox for every instance originating from this map to have the same value.  (Any value not in $. syntax will be considered a constant.)
    </div>
    @if (mapIsSubordinate(entityMap)) {
      <div class="cell small-12 map-comment">
        Editing the value for the field selected in the "Relates to Parent" drop down list is disabled.  This field will be auto-populated to connect the generated
        child entities to their parents and cannot be directly mapped with another value.
      </div>
    }
  </div>
  @for (map of entityMap.propertyMaps; track map) {
    <div class="minor-margin-top">
      <workflow-entity-map [entityMap]="entityMap" [propertyMap]="map" [entityName]="entityMap.entity.entityName" [template]="template" class="full-width" [contextValue]="contextValue"></workflow-entity-map>
    </div>
  }
}